// Video Overlay Modal
let youtubePlayer;
let isVideoPaused = false;
let isVideoModalSlideIn = false;
let userInteracted = false;
let isVideoEnded = false;
let videoCheckInterval;
let videoStartTime;
let pauseCount = 0;
let totalWatchTime = 0;
let lastPauseTime;
let sessionId = generateSessionId();
let isFullscreen = false;
let isReopening = false; // Flag to prevent state handler from interfering during reopen

function generateSessionId() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

function togglePlayPauseIcon(linkElement, showPlay) {
  if (!userInteracted) return;  // Don't change icon if user hasn't interacted

  const iconContainer = linkElement.querySelector('.icon-container');
  const playIcon = iconContainer.querySelector('.play-icon');
  const pauseIcon = iconContainer.querySelector('.pause-icon');
  
  if (showPlay) {
    playIcon.classList.add('active');
    pauseIcon.classList.remove('active');
  } else {
    playIcon.classList.remove('active');
    pauseIcon.classList.add('active');
  }
}

function checkVideoNearEnd() {
  if (youtubePlayer && youtubePlayer.getCurrentTime && youtubePlayer.getDuration) {
    const currentTime = youtubePlayer.getCurrentTime();
    const duration = youtubePlayer.getDuration();
    const timeRemaining = duration - currentTime;
    
    if (timeRemaining <= 2 && !isVideoEnded) {  // Changed from 1 to 2 seconds
      isVideoEnded = true;
      showPauseScreen();
    }
  }
}

function showPauseScreen() {
  const clickOverlay = document.getElementById('click-overlay');
  clickOverlay.style.backgroundColor = '#0A0A0A';
  clickOverlay.classList.add('paused');
  
  const playButton = clickOverlay.querySelector('.play-button-svg');
  const feedbackDiv = clickOverlay.querySelector('.video-feedback');
  if (playButton) {
    playButton.style.opacity = '1';
  }
  if (feedbackDiv) {
    feedbackDiv.style.display = 'block';
  }
  
  const link = document.querySelector('.product-inventory__watch-review');
  togglePlayPauseIcon(link, true);
  
  // Pause the video after a short delay
  setTimeout(() => {
    if (youtubePlayer && youtubePlayer.pauseVideo) {
      youtubePlayer.pauseVideo();
    }
  }, 100);
}

function startVideoEndCheck() {
  stopVideoEndCheck();  // Clear any existing interval before starting a new one
  videoCheckInterval = setInterval(checkVideoNearEnd, 100);  // Check every 100ms
}

function stopVideoEndCheck() {
  clearInterval(videoCheckInterval);
}

function onYouTubeIframeAPIReady() {
  const videoModal = document.getElementById('video-modal');
  const clickOverlay = document.getElementById('click-overlay');
  
  if (videoModal) {
    const videoUrl = videoModal.getAttribute('data-video-url');
    
    if (videoUrl) {
      let videoId;
      if (videoUrl.includes('v=')) {
        videoId = videoUrl.split('v=')[1].split('&')[0];
      } else if (videoUrl.includes('/shorts/')) {
        videoId = videoUrl.split('/shorts/')[1].split('?')[0];
      }

      youtubePlayer = new YT.Player('video-player', {
        height: '320',
        width: '180',
        videoId: videoId,
        playerVars: {
          'autoplay': 1,
          'mute': 1,
          'controls': 0,
          'rel': 0,
          'iv_load_policy': 3,
          'fs': 0,
          'disablekb': 1,
          'playsinline': 1
        },
        events: {
          'onReady': function(event) {},
          'onError': function(event) {
            console.warn('[Sanction Video] Player error:', event.data);
          },
          'onStateChange': function(event) {
            const link = document.querySelector('.product-inventory__watch-review');
            if (event.data === YT.PlayerState.PLAYING) {
              // Reveal video now that it's actually playing
              var overlay = document.getElementById('click-overlay');
              var iframe = videoModal ? videoModal.querySelector('iframe') : null;
              if (isReopening && iframe) {
                // Keep the dark overlay covering the iframe long enough for
                // YouTube's title / pause icon / Shorts logo to fade out on
                // their own before we reveal the video. (Needs ~3s; YouTube
                // restarts that fade timer on every playVideo() / seekTo().)
                setTimeout(function() {
                  iframe.style.transition = 'opacity 300ms ease';
                  iframe.style.opacity = '1';
                  setTimeout(function() {
                    if (overlay) {
                      overlay.style.transition = 'background-color 300ms ease';
                      overlay.style.backgroundColor = 'transparent';
                    }
                    // Clean up transitions
                    setTimeout(function() {
                      iframe.style.transition = '';
                      if (overlay) overlay.style.transition = '';
                    }, 300);
                  }, 150);
                }, 1200);
              } else {
                if (iframe) {
                  iframe.style.transition = 'opacity 250ms ease';
                  iframe.style.opacity = '1';
                  setTimeout(function() { iframe.style.transition = ''; }, 250);
                }
                if (overlay) {
                  overlay.style.transition = 'background-color 250ms ease';
                  overlay.style.backgroundColor = 'transparent';
                  setTimeout(function() { overlay.style.transition = ''; }, 250);
                }
              }

              if (!videoStartTime) {
                videoStartTime = new Date();
              } else if (lastPauseTime) {
                totalWatchTime += (new Date() - lastPauseTime) / 1000;
                lastPauseTime = null;
              }
              togglePlayPauseIcon(link, false);
              isVideoPaused = false;
              isVideoEnded = false;
              startVideoEndCheck();
            } else if (event.data === YT.PlayerState.PAUSED) {
              // Don't update pause state if we're in the process of reopening and playing
              if (isReopening) {
                return;
              }
              // Only update pause state if modal is actually open and enlarged
              // This prevents the state from being set to paused when reopening
              if (videoModal && videoModal.classList.contains('enlarge') && videoModal.style.display !== 'none') {
                togglePlayPauseIcon(link, true);
                isVideoPaused = true;
                pauseCount++;
                lastPauseTime = new Date();
                stopVideoEndCheck();
              }
            } else if (event.data === YT.PlayerState.ENDED) {
              isVideoPaused = true;
              isVideoEnded = true;
              togglePlayPauseIcon(link, true);
              stopVideoEndCheck();
              showPauseScreen();  // Add this line to ensure the pause screen is shown
            }
          }
        }
      });
      
      setTimeout(() => {
        videoModal.classList.add('slide-in');
        isVideoModalSlideIn = true;
      }, 5000);
    }
  } else {
    // No video on this page — do nothing
    return;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const clickOverlay = document.getElementById('click-overlay');
  const videoModal = document.getElementById('video-modal');
  const closeBtn = document.getElementById('close-btn');
  const watchReviewLinks = document.querySelectorAll('.product-inventory__watch-review');

  // Add these variables for swipe detection
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;

  function handleVideoClick(linkElement) {
    userInteracted = true;  // Set user interaction flag

    if (!isVideoModalSlideIn) {
      videoModal.classList.add('slide-in');
      isVideoModalSlideIn = true;
    }

    // Keep overlay dark until video is actually playing (prevents YouTube UI flash)
    clickOverlay.style.backgroundColor = '#0A0A0A';
    clickOverlay.classList.remove('paused');

    // Hide the play button and feedback
    const playButton = clickOverlay.querySelector('.play-button-svg');
    const feedbackDiv = clickOverlay.querySelector('.video-feedback');
    if (playButton) {
      playButton.style.opacity = '0';
    }
    if (feedbackDiv) {
      feedbackDiv.style.display = 'none';
    }

    // If modal doesn't have enlarge class, it means it was closed and reopened
    // Always start playing from the beginning in this case
    if (!videoModal.classList.contains('enlarge')) {
      // Starting fresh or reopening - always play from start
      // Set flag to prevent state handler from interfering
      isReopening = true;
      
      // Force reset all state first
      isVideoPaused = false;
      isVideoEnded = false;
      
      // Hide the iframe and ensure dark bg BEFORE adding enlarge class
      var iframe = videoModal.querySelector('iframe');
      if (iframe) {
        iframe.style.transition = 'none';
        iframe.style.opacity = '0';
      }
      clickOverlay.style.transition = 'none';
      clickOverlay.style.backgroundColor = '#0A0A0A';

      // Force a reflow so styles apply before the class triggers the animation
      void videoModal.offsetHeight;

      videoModal.classList.add('enlarge');

      if (youtubePlayer) {
        // Only restart the video if it has actually ended (or is at the very
        // end). Seeking on a video that's still playing makes YouTube treat
        // it as a fresh start and re-shows the title / Shorts overlays — we
        // want to avoid that whenever possible.
        try {
          const state = youtubePlayer.getPlayerState();
          const current = youtubePlayer.getCurrentTime ? youtubePlayer.getCurrentTime() : 0;
          const duration = youtubePlayer.getDuration ? youtubePlayer.getDuration() : 0;
          const isEnded = state === 0 || (duration > 0 && current >= duration - 0.5);
          if (isEnded) {
            youtubePlayer.seekTo(0);
          }
        } catch (e) {
          // If we can't read state, fall back to not seeking — better to
          // continue mid-video than to re-trigger the YouTube overlays.
        }
        youtubePlayer.unMute();
        
        // Force play - use multiple attempts to ensure it works
        const playVideo = () => {
          try {
            const playerState = youtubePlayer.getPlayerState();
            // If player is stopped (-1) or paused (2) or ended (0), we need to play
            if (playerState === -1 || playerState === 2 || playerState === 0) {
              youtubePlayer.playVideo();
              isVideoPaused = false;
              isVideoEnded = false;
            }
          } catch (e) {
            // Retry on next attempt
          }
        };
        
        // Try immediately
        playVideo();
        
        // Try again after short delays
        setTimeout(playVideo, 100);
        setTimeout(playVideo, 300);
        setTimeout(() => {
          playVideo();
          // Clear the reopening flag after we've attempted to play
          setTimeout(() => {
            isReopening = false;
          }, 500);
        }, 500);

        // Safety: if the video was already PLAYING (typical case after
        // background autoplay) no PLAYING state event will fire, so the
        // dark-overlay reveal animation never runs. Force the reveal here
        // after the scale transition finishes.
        setTimeout(() => {
          var iframe = videoModal.querySelector('iframe');
          if (iframe && iframe.style.opacity === '0') {
            iframe.style.transition = 'opacity 300ms ease';
            iframe.style.opacity = '1';
            setTimeout(() => {
              clickOverlay.style.transition = 'background-color 300ms ease';
              clickOverlay.style.backgroundColor = 'transparent';
              setTimeout(() => {
                iframe.style.transition = '';
                clickOverlay.style.transition = '';
              }, 300);
            }, 150);
          }
        }, 600);
      } else {
        // If no player yet, clear flag after a delay
        setTimeout(() => {
          isReopening = false;
        }, 1000);
      }
      
      videoStartTime = new Date();  // Set video start time
      
      // Switch to pause icon immediately
      togglePlayPauseIcon(linkElement, false);
      startVideoEndCheck();
    } else {
      // Modal is already enlarged - toggle play/pause
      if (isVideoPaused || isVideoEnded) {
        youtubePlayer.playVideo();
        isVideoPaused = false;
        isVideoEnded = false;  // Reset this flag
        
        // Switch to pause icon
        togglePlayPauseIcon(linkElement, false);
        
        startVideoEndCheck();
      } else {
        // Add overlay styling
        clickOverlay.style.backgroundColor = '#0A0A0A';
        clickOverlay.classList.add('paused');
        
        // Show the play button and feedback
        if (playButton) {
          playButton.style.opacity = '1';
        }
        if (feedbackDiv) {
          feedbackDiv.style.display = 'block';
        }
        
        // Pause the video after a delay
        setTimeout(() => {
          youtubePlayer.pauseVideo();
          isVideoPaused = true;
          
          // Switch to play icon
          togglePlayPauseIcon(linkElement, true);
        }, 500);
        stopVideoEndCheck();
      }
    }
  }

  function closeVideoModal() {
    // Exit fullscreen if active
    if (isFullscreen) {
      exitFullscreen();
    }
    
    // Always restore header z-index when closing
    restoreHeaderZIndex();
    
    videoModal.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
    videoModal.style.transform = 'translateX(-100%)';
    videoModal.style.opacity = '0';
    
    setTimeout(() => {
      videoModal.style.display = 'none';
      videoModal.style.transform = '';
      videoModal.style.opacity = '';
      videoModal.style.transition = '';
      
      // Remove enlarge class to reset modal state
      videoModal.classList.remove('enlarge');
      
      // Explicitly reset fullscreen state to ensure clean reopening
      videoModal.classList.remove('fullscreen-active');
      isFullscreen = false;
      updateFullscreenIcon();
      
      if (youtubePlayer) {
        // Use pauseVideo instead of stopVideo to keep player in a playable state
        youtubePlayer.pauseVideo();
        youtubePlayer.seekTo(0);
        // Mute the video so it starts muted when reopened
        youtubePlayer.mute();
      }
      // Reset all icons to play state when closing the video
      document.querySelectorAll('.product-inventory__watch-review').forEach(link => {
        togglePlayPauseIcon(link, true);
      });
      isVideoPaused = true;
      isVideoEnded = false;
      userInteracted = false;  // Reset user interaction flag
      clickOverlay.classList.remove('paused');  // Remove paused class when closing
      clickOverlay.style.backgroundColor = 'transparent';  // Reset background color
      stopVideoEndCheck();
    }, 300);
  }

  function enterFullscreen() {
    const videoModal = document.getElementById('video-modal');
    if (!videoModal) return;

    // Try different fullscreen methods for cross-browser compatibility
    if (videoModal.requestFullscreen) {
      videoModal.requestFullscreen().catch(function() {
        simulateFullscreen();
      });
    } else if (videoModal.webkitRequestFullscreen) { // Safari
      videoModal.webkitRequestFullscreen();
    } else if (videoModal.mozRequestFullScreen) { // Firefox
      videoModal.mozRequestFullScreen();
    } else if (videoModal.msRequestFullscreen) { // IE/Edge
      videoModal.msRequestFullscreen();
    } else if (videoModal.webkitEnterFullscreen) { // iOS Safari
      videoModal.webkitEnterFullscreen();
    } else {
      // Fallback for devices that don't support fullscreen API
      simulateFullscreen();
    }
  }

  function simulateFullscreen() {
    const videoModal = document.getElementById('video-modal');
    if (!videoModal) return;
    
    // Manually add fullscreen-active class and adjust modal state
    videoModal.classList.add('fullscreen-active');
    isFullscreen = true;
    updateFullscreenIcon();
    
    // Force header and other high z-index elements to be below the video
    const header = document.querySelector('.section-header');
    const logoArea = document.querySelector('.logo-area');
    const announcement = document.querySelector('.announcement-bar');
    
    if (header) {
      header.style.zIndex = '1';
    }
    if (logoArea) {
      logoArea.style.zIndex = '1';
    }
    if (announcement) {
      announcement.style.zIndex = '1';
    }
    
    // Ensure video continues playing
    if (youtubePlayer && isVideoPaused === false) {
      youtubePlayer.playVideo();
    }
  }

  function exitSimulatedFullscreen() {
    const videoModal = document.getElementById('video-modal');
    if (!videoModal) return;
    
    videoModal.classList.remove('fullscreen-active');
    isFullscreen = false;
    updateFullscreenIcon();
    
    // Restore original z-index by removing inline styles
    restoreHeaderZIndex();
  }

  function restoreHeaderZIndex() {
    const header = document.querySelector('.section-header');
    const logoArea = document.querySelector('.logo-area');
    const announcement = document.querySelector('.announcement-bar');
    
    if (header) {
      header.style.removeProperty('z-index');
    }
    if (logoArea) {
      logoArea.style.removeProperty('z-index');
    }
    if (announcement) {
      announcement.style.removeProperty('z-index');
    }
  }

  function exitFullscreen() {
    const videoModal = document.getElementById('video-modal');
    
    // Check if we're in simulated fullscreen mode
    if (videoModal && videoModal.classList.contains('fullscreen-active') && !document.fullscreenElement && !document.webkitFullscreenElement) {
      exitSimulatedFullscreen();
      return;
    }
    
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { // Safari
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) { // Firefox
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) { // IE/Edge
      document.msExitFullscreen();
    } else {
      exitSimulatedFullscreen();
    }
  }

  function toggleFullscreen() {
    if (isFullscreen) {
      exitFullscreen();
    } else {
      // Unmute audio when entering fullscreen
      if (youtubePlayer && youtubePlayer.unMute) {
        youtubePlayer.unMute();
      }
      enterFullscreen();
    }
  }

  function updateFullscreenIcon() {
    const fullscreenBtn = document.getElementById('fullscreen-btn');
    if (!fullscreenBtn) return;

    const fullscreenIcon = fullscreenBtn.querySelector('.fullscreen-icon');
    const shrinkIcon = fullscreenBtn.querySelector('.shrink-icon');

    if (isFullscreen) {
      fullscreenIcon.style.display = 'none';
      shrinkIcon.style.display = 'block';
    } else {
      fullscreenIcon.style.display = 'block';
      shrinkIcon.style.display = 'none';
    }
  }

  function handleFullscreenChange() {
    const videoModal = document.getElementById('video-modal');
    const isCurrentlyFullscreen = !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );

    // Don't update if we're in simulated fullscreen mode
    if (videoModal && videoModal.classList.contains('fullscreen-active') && !isCurrentlyFullscreen) {
      // We're in simulated mode, don't change state based on actual fullscreen
      return;
    }

    if (isCurrentlyFullscreen !== isFullscreen) {
      isFullscreen = isCurrentlyFullscreen;
      updateFullscreenIcon();
      
      if (videoModal) {
        if (isFullscreen) {
          videoModal.classList.add('fullscreen-active');
          
          // Force header and other high z-index elements to be below the video
          const header = document.querySelector('.section-header');
          const logoArea = document.querySelector('.logo-area');
          const announcement = document.querySelector('.announcement-bar');
          
          if (header) {
            header.style.zIndex = '1';
          }
          if (logoArea) {
            logoArea.style.zIndex = '1';
          }
          if (announcement) {
            announcement.style.zIndex = '1';
          }
          
          // Ensure video continues playing in fullscreen
          if (youtubePlayer && isVideoPaused === false) {
            youtubePlayer.playVideo();
          }
        } else {
          videoModal.classList.remove('fullscreen-active');
          
          // Restore original z-index by removing inline styles
          // Add a small delay to ensure it happens after fullscreen transition
          setTimeout(() => {
            restoreHeaderZIndex();
          }, 100);
        }
      }
    }
  }

  // Only set up video modal if we have the required elements
  if (clickOverlay && videoModal) {
    // Add touch event listeners for swipe detection
    videoModal.addEventListener('touchstart', function(e) {
      // Don't track swipe if touching buttons or feedback
      if (e.target.closest('.fullscreen-btn') ||
          e.target.closest('.close-btn') ||
          e.target.closest('.restart-btn') ||
          e.target.closest('.video-feedback')) {
        return;
      }
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    });

    videoModal.addEventListener('touchend', function(e) {
      // Don't handle swipe if touching buttons or feedback
      if (e.target.closest('.fullscreen-btn') ||
          e.target.closest('.close-btn') ||
          e.target.closest('.restart-btn') ||
          e.target.closest('.video-feedback')) {
        return;
      }
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    });

    function handleSwipe() {
      const swipeThreshold = 30; // Reduced threshold for more sensitivity
      const swipeVerticalThreshold = 30; // Reduced threshold for vertical movement
      const swipeDistance = touchStartX - touchEndX;
      const swipeVerticalDistance = Math.abs(touchStartY - touchEndY);

      if (swipeDistance > swipeThreshold && swipeVerticalDistance < swipeVerticalThreshold) {
        // Swipe left detected
        closeVideoModal();
      }
    }

    clickOverlay.addEventListener('click', function(e) {
      // Don't trigger if clicking on fullscreen or close buttons or feedback
      if (e.target.closest('.fullscreen-btn') ||
          e.target.closest('.close-btn') ||
          e.target.closest('.restart-btn') ||
          e.target.closest('.video-feedback')) {
        return;
      }
      if (e.target === clickOverlay || e.target.classList.contains('play-button-svg')) {
        const firstWatchLink = document.querySelector('.product-inventory__watch-review');
        if (firstWatchLink) {
          handleVideoClick(firstWatchLink);
        }
      }
    });
    
    // Add play button SVG and feedback elements to click overlay
    const overlayContent = `
      <svg class="play-button-svg" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M38 24.0001L15 37.9282L15 10.072L38 24.0001Z" fill="white"/>
      </svg>
      <div class="video-feedback" style="display: none;">
        <p class="feedback-text">Want to see more videos like this?</p>
        <div class="feedback-buttons">
          <span class="feedback-emoji" data-feedback="up">👍</span>
          <span class="feedback-emoji" data-feedback="down">👎</span>
        </div>
        <p class="feedback-thanks" style="display: none;">Thanks for your response!</p>
      </div>
    `;
    clickOverlay.insertAdjacentHTML('beforeend', overlayContent);

    // Add fullscreen button to video modal (only if it doesn't exist)
    let fullscreenBtn = document.getElementById('fullscreen-btn');
    if (!fullscreenBtn) {
      fullscreenBtn = document.createElement('div');
      fullscreenBtn.id = 'fullscreen-btn';
      fullscreenBtn.className = 'fullscreen-btn';
      fullscreenBtn.innerHTML = `
        <svg class="fullscreen-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M16 4l4 0l0 4" />
          <path d="M14 10l6 -6" />
          <path d="M8 20l-4 0l0 -4" />
          <path d="M4 20l6 -6" />
        </svg>
        <svg class="shrink-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: none;">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M6 10h4v-4" />
          <path d="M4 4l6 6" />
          <path d="M18 14h-4v4" />
          <path d="M14 14l6 6" />
        </svg>
      `;
      
      // Handle both click and touch events for better mobile support
      const handleFullscreenToggle = function(e) {
        e.stopPropagation();
        e.preventDefault();
        toggleFullscreen();
      };
      
      fullscreenBtn.addEventListener('click', handleFullscreenToggle);
      fullscreenBtn.addEventListener('touchend', handleFullscreenToggle);
      
      videoModal.appendChild(fullscreenBtn);
      // Initialize icon state
      updateFullscreenIcon();
    }

    // Add restart button to video modal (only if it doesn't exist)
    let restartBtn = document.getElementById('restart-btn');
    if (!restartBtn) {
      restartBtn = document.createElement('div');
      restartBtn.id = 'restart-btn';
      restartBtn.className = 'restart-btn';
      restartBtn.setAttribute('aria-label', 'Restart video');
      restartBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M19.95 11a8 8 0 1 0 -.5 4" />
          <path d="M20 4v5h-5" />
        </svg>
      `;

      const handleRestart = function(e) {
        e.stopPropagation();
        e.preventDefault();
        if (!youtubePlayer) return;

        // Brief dark flash so the restart feels intentional rather than
        // an abrupt YouTube UI pop-in. Not long enough to be annoying.
        clickOverlay.style.transition = 'none';
        clickOverlay.style.backgroundColor = '#0A0A0A';
        void videoModal.offsetHeight; // force reflow so the transition below runs

        try {
          youtubePlayer.seekTo(0);
          youtubePlayer.playVideo();
          isVideoPaused = false;
          isVideoEnded = false;
        } catch (err) {
          // ignore
        }

        setTimeout(() => {
          clickOverlay.style.transition = 'background-color 300ms ease';
          clickOverlay.style.backgroundColor = 'transparent';
          setTimeout(() => { clickOverlay.style.transition = ''; }, 300);
        }, 500);
      };

      restartBtn.addEventListener('click', handleRestart);
      restartBtn.addEventListener('touchend', handleRestart);

      videoModal.appendChild(restartBtn);
    }

    // Listen for fullscreen changes (including ESC key)
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    // Add event listeners for feedback emojis
    const feedbackButtons = clickOverlay.querySelectorAll('.feedback-emoji');
    feedbackButtons.forEach(button => {
      button.addEventListener('click', handleFeedback);
    });
  }

  if (!clickOverlay || !videoModal) return;

  // Open/resume the video modal from a watch-review link
  function openFromLink(e, link) {
    e.preventDefault();
    e.stopPropagation();
    if (!videoModal) return;

    // Reset modal state when reopening
    const wasClosed = videoModal.style.display === 'none' || !videoModal.classList.contains('enlarge');
    videoModal.style.display = 'block';

    if (wasClosed) {
      videoModal.classList.remove('enlarge');
      isVideoPaused = false;
      isVideoEnded = false;
    }

    // Small delay to ensure modal is visible before playing
    setTimeout(() => {
      handleVideoClick(link);
    }, 50);
  }

  // Add event listeners to all "product-inventory__watch-review" elements
  watchReviewLinks.forEach(link => {
    link.addEventListener('click', function(e) { openFromLink(e, this); });

    const iconContainer = link.querySelector('.icon-container');
    if (iconContainer) {
      iconContainer.addEventListener('click', function(e) { openFromLink(e, link); });
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeVideoModal);
  }
});

function getProductId() {
  // Try to get the product ID from the meta tag
  let productId = document.querySelector('meta[property="product:id"]')?.content;
  
  // If not found, try to get it from the body's data attribute
  if (!productId) {
    productId = document.body.getAttribute('data-product-id');
  }
  
  // If still not found, try to get it from the URL
  if (!productId) {
    const urlParts = window.location.pathname.split('/');
    productId = urlParts[urlParts.length - 1];
  }
  
  return productId || 'unknown';
}

function sendFeedbackToGoogleSheet(productId, feedback) {
  
  const now = new Date();
  const timeZone = 'America/Toronto';
  
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  const timeFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timeZone,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  const formattedDate = dateFormatter.format(now);
  const formattedTime = timeFormatter.format(now);
  const timestamp = `${formattedDate} ${formattedTime}`;

  const deviceType = getDeviceType();
  const browser = getBrowser();
  const actualWatchTime = Math.round(totalWatchTime + (lastPauseTime ? (now - lastPauseTime) / 1000 : 0));
  const dayOfWeek = now.toLocaleString('en-US', { timeZone: timeZone, weekday: 'long' });
  const videoId = youtubePlayer.getVideoData().video_id;

  fetch('https://script.google.com/macros/s/AKfycby8vcdM2aByHdlQ62m3Ma_Vx08XSGdpqAgcFwaAXhgkkk71CBShaRa-4AEXn_yF16Rxvg/exec', {
    method: 'POST',
    mode: 'no-cors', // This is important for CORS issues
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      timestamp: timestamp,
      productId: productId,
      feedback: feedback,
      deviceType: deviceType,
      browser: browser,
      actualWatchTime: actualWatchTime,
      pauseCount: pauseCount,
      dayOfWeek: dayOfWeek,
      timeOfDay: formattedTime,
      videoId: videoId,
      sessionId: sessionId
    }),
  })
  .then(function() {})
  .catch(function(error) {
    console.warn('[Sanction Video] Feedback error:', error);
  });
}

function getDeviceType() {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop";
}

function getBrowser() {
  const ua = navigator.userAgent;
  let browser = "unknown";

  if (ua.indexOf("Chrome") > -1) {
    browser = "Chrome";
  } else if (ua.indexOf("Safari") > -1) {
    browser = "Safari";
  } else if (ua.indexOf("Firefox") > -1) {
    browser = "Firefox";
  } else if (ua.indexOf("MSIE") > -1 || ua.indexOf("Trident/") > -1) {
    browser = "Internet Explorer";
  } else if (ua.indexOf("Edge") > -1) {
    browser = "Edge";
  }

  return browser;
}

function handleFeedback(e) {
  e.stopPropagation(); // Prevent click from bubbling up to clickOverlay

  const feedback = e.target.dataset.feedback;
  const productId = getProductId();
  
  // Send feedback to Google Sheet
  sendFeedbackToGoogleSheet(productId, feedback);
  
  // Hide feedback buttons and show thanks message
  const feedbackDiv = e.target.closest('.video-feedback');
  const buttonsDiv = feedbackDiv.querySelector('.feedback-buttons');
  const thanksMsg = feedbackDiv.querySelector('.feedback-thanks');
  const feedbackText = feedbackDiv.querySelector('.feedback-text');
  
  // Immediately hide the buttons and feedback text
  buttonsDiv.style.display = 'none';
  feedbackText.style.display = 'none';
  
  // Show and fade in the thanks message
  thanksMsg.style.display = 'block';
  thanksMsg.style.opacity = '0';
  
  // Use requestAnimationFrame to ensure the browser has time to apply the display change
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      thanksMsg.style.transition = 'opacity 0.3s ease';
      thanksMsg.style.opacity = '1';
    });
  });

}





